module.exports = __webpack_public_path__ + "img/11.64c125f5.png";